import { eThongKeCSKHActionDefine } from "../../action-types/thong-ke/IThongKeCSKHActions";
import { generateActions } from "../generateActions";

export const thongKeCSKHActions = {
    ...generateActions(eThongKeCSKHActionDefine, "THONG_KE_CSKH"),
}